module.exports = __webpack_public_path__ + "fonts/Inter-600-vietnamese40.9df1755.woff2";